import { useCallback, useContext, useEffect, useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';
import { applyStudentStartYearDomain, handleNext, onStartOrEndYearChange } from './ProgramBasicInfoActions';
import OutcomeLayout from './ProgramBasicInfoLayout';
import SessionContext from '../../../../library/Core/SessionContext';
import axios from 'axios';
import { getFlexColDomainValueForCode, isEmpty } from '../../../../library/Core/SmartFunctions';
import { axiosClient } from '../../../../library/Service/axiosClient';

const ProgramBasicInfo = () => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');
    let programLevel = '';
    const { sessionState, sessionDispatch } = useContext(SessionContext);

    const handleStartYearChange = useCallback(
        (event:any) => onStartOrEndYearChange(event, sessionState,programLevel),
        [sessionState,programLevel] // Dependency ensures it gets the latest sessionState
    );
    
    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            NEXT: handleNext,
            ROUTER_NAVIGATE: navigate,
            REDIRECT: setRedirectUrl,
            startYear:  handleStartYearChange,
            passOutYear: handleStartYearChange,
            sessionState: sessionState,
        },
    } as any);

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;
    const getSocialProfileLinks = () => {
        return globalState.domain?.get('SOCIAL_NETWORK_CODE')?.map((item: any) => ({ socialNetworkCode: item.code, link: '' }));
    };
    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    useEffect(() => {
        if(sessionState?.userTypeCode == 'SUPER_ADMIN' || sessionState?.userTypeCode == 'INSTITUTE_ADMIN'){
            if (localStorage.getItem('selectedInstitute') == undefined) {
                return navigate(`/alumni/${data?.id}/select-institute`);
            }
        }

        const getProgramLevel = async () => {
            const response = await axiosClient().get(
                `${process.env.REACT_APP_COMMON_API}/users/get-program-level-by-program-id/${data?.selectedInstitute?.programId}`
            );

            if(response.data.success == 1){
                const programLevelResponse = response.data.data.programLevel;
                // sessionDispatch({ type: 'SET', payload: {...sessionState,programLevel:programLevel} });
                programLevel = programLevelResponse;
            }
        }

        // Set default social links if not present and also add agreeToUnivariety field with default value as false
        let derivedData = {
        ...data,
        socialLinks: isEmpty(data?.socialLinks)
            ? [{ socialNetworkCode: 'LINKEDIN', link: '' }]
            : data.socialLinks,
        user: {
            ...data?.user,
            agreeToUnivariety: data?.agreeToUnivariety ?? false,
        },
       };

       // set aggre to univariety checkbox to true if data.agreeToUnivariety is true
        // if(data?.agreeToUnivariety){
        //     // controll value change to set checkbox to true
        //     dispatch({
        //         type: 'CONTROL_VALUE_CHANGE',
        //         payload: {
        //             dataKey: 'agreeToUnivariety',
        //             value: true,
        //         },  
        //     })
        // }
        const domainMap = new Map([...globalState.domain]);
        const domain = addUserSpecificDomains(new Map([...domainMap]), derivedData);
        const statuses = domain.get('POST_PROGRAM_COMPLETION_STATUS_CODE');

        if (statuses?.length) {
            const normalStatuses: any[] = [];
            const workingStatuses: any[] = [];

            statuses.forEach((status: any) => {
                if (!status.flexCol) {
                    normalStatuses.push(status);
                    return;
                }
                let flex = status.flexCol;
                if (typeof flex === 'string') {
                    try {
                        flex = JSON.parse(flex);
                    } catch {
                        normalStatuses.push(status);
                        return;
                    }
                }

                if (flex?.is_working === 1) {
                    workingStatuses.push(status);
                } else {
                    normalStatuses.push(status);
                }
            });
            domain.set('POST_PROGRAM_COMPLETION_STATUS_CODE', normalStatuses);
            domain.set('POST_PROGRAM_COMPLETION_STATUS_CODE_WORKING', workingStatuses);
        }

        
        const loadSchoolSettings = async () => {
            const response = await axios.get(
                `${process.env.REACT_APP_PAGE_CONFIG_SERVER}/v1/appConfig/outcome-page-program-domain-data/${data?.selectedInstitute?.instituteId}`
            );
            
            console.log("response.data",response.data)
            domainMap.set('INSTITUTE_PROGRAM_CODE', response.data);
            const domain = applyStudentStartYearDomain(
                addUserSpecificDomains(new Map([...domainMap]), derivedData),
                derivedData,
                sessionState
            );
           // if (isEmpty(data?.socialLinks)) data['socialLinks'] = getSocialProfileLinks();
            dispatch({
                type: 'DATA_INIT',
                payload: { formConfig, data: derivedData, internal, domain, routeInfo },
            });
        };
        if(!isEmpty(data?.selectedInstitute)) loadSchoolSettings();
        if(isEmpty(sessionState?.programLevel)) getProgramLevel();
    }, []);

    let postProgramCompletionStatusCode = state?.data?.selectedInstitute?.postProgramCompletionStatusCode;
    console.log("postProgramCompletionStatusCode",postProgramCompletionStatusCode)
    const flexCol = getFlexColDomainValueForCode(postProgramCompletionStatusCode, 'POST_PROGRAM_COMPLETION_STATUS_CODE_WORKING', state);
    console.log("flexCol",flexCol)

    console.log("user data in program basic info",state?.data?.user)
    const is_working = isEmpty(flexCol) ? '' : JSON.parse(flexCol).is_working;
    const higherStudyOptions = ['JOINED_SCHOOL', 'JOINED_UG', 'JOINED_PG', 'JOINED_DOCTORAL'];
    if (higherStudyOptions.includes(postProgramCompletionStatusCode) || is_working) {
        postProgramCompletionStatusCode = is_working ? 'WORKING' : 'WENT_FOR_HIGHER_STUDIES';

        let selectedInstitute = { ...state?.data?.selectedInstitute };
        selectedInstitute.postProgramCompletionStatusCode = postProgramCompletionStatusCode;

        dispatch({ type: 'REFRESH_DATA', payload: { data: { ...state?.data,       user: {
        ...state?.data?.user,
        agreeToUnivariety: data?.agreeToUnivariety ?? false,
      }, selectedInstitute: selectedInstitute } } });
    } 

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <OutcomeLayout>{!state.flags.isDataLoading && <PageBuilder />}</OutcomeLayout>
        </SmartContext.Provider>
    );
};

export default ProgramBasicInfo;
